module.exports = __webpack_public_path__ + "static/LightFeather_Logo_2021-95611b99f93c860f28a5b0b3390d522b.png";